module.exports = __webpack_public_path__ + "img/logo-sm-not-log-in.39ecbec0.png";